import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Notifications from 'vue-notification'
import VuePaginate from 'vue-paginate'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'

Vue.config.productionTip = false;
Vue.prototype.$url = 'https://api.para-ti.com.ar/api/';
Vue.prototype.$ganancia = 30;

Vue.prototype.$token = localStorage.getItem('token');


import 'bootstrap-vue/dist/bootstrap-vue.css'
//import 'vue-search-select/dist/VueSearchSelect.css'



Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(ModalPlugin)


 
Vue.use(Notifications)
Vue.use(VuePaginate)

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
